// frontend/src/content/officialProfiles.js
//
// The SINGLE SOURCE of Leadify AI's official profiles on other platforms.
// Two consumers read it:
//   * Homepage.js's Organization JSON-LD `sameAs` (OFFICIAL_PROFILE_URLS) -
//     the signal Google and AI answer engines use to fuse our scattered
//     mentions into ONE entity and to DISAMBIGUATE us from the unrelated
//     brands "leadify.ai" and "leadify.biz" (different companies competing
//     for the same name). It is the only Organization node that carries
//     `sameAs`; every other page's Organization is a bare publisher/provider
//     reference.
//   * the follow-us icon row (components/shared/SocialLinks.js) in the public
//     footer and on the contact page (SOCIAL_PROFILES).
//
// OWNER-CONFIRMED URLs ONLY: a wrong `sameAs` welds a stranger's page to our
// entity, and a wrong footer link sends a visitor to one. Our Facebook handle
// is /leadifyai/ - NOT the unrelated "@leadify.biz" page.
//
// Google Business Profile: the owner gave the REVIEW-writing link
// (g.page/r/<id>/review). `sameAs` takes the PROFILE link - the same short
// link without "/review". Verified 2026-10-23: it resolves to Google's
// business-profile view of "Leadify AI" (ludocid 9523593504137450602, which
// is also the CID the <id> token encodes). Never put the /review link here.
// It is a sameAs entry only - not a footer icon (owner's icon set is
// Facebook, Instagram, LinkedIn).

/** Every official profile, in display order. `social` = shown as an icon. */
export const OFFICIAL_PROFILES = [
  {
    id: "facebook",
    url: "https://www.facebook.com/leadifyai/",
    name: { he: "פייסבוק", en: "Facebook" },
    social: true,
  },
  {
    id: "instagram",
    url: "https://www.instagram.com/leadifyai/",
    name: { he: "אינסטגרם", en: "Instagram" },
    social: true,
  },
  {
    id: "linkedin",
    url: "https://www.linkedin.com/company/leadifyai-biz",
    name: { he: "לינקדאין", en: "LinkedIn" },
    social: true,
  },
  {
    id: "google",
    url: "https://g.page/r/CWqUVHfVmSqEEBM",
    name: { he: "Google", en: "Google" },
    social: false,
  },
];

/** The Organization `sameAs` list (Homepage.js JSON-LD). */
export const OFFICIAL_PROFILE_URLS = OFFICIAL_PROFILES.map((p) => p.url);

/** The follow-us icons, in the owner's order: Facebook, Instagram, LinkedIn. */
export const SOCIAL_PROFILES = OFFICIAL_PROFILES.filter((p) => p.social);
